<script>

/*==================================================================*/
/*========================= VUE IMPORTS ============================*/
/*==================================================================*/

import Vue from 'vue';

/*==================================================================*/
/*================= MODAIS RECEBIMENTO DE NOTA FISCAL ==============*/
/*==================================================================*/

// import RecebimentoDeNotaFiscalBarcodeModal from './RecebimentoDeNotaFiscalBarcodeModalView.vue';
import RecebimentoDeNotaFiscalRejeitarItemModal from './RecebimentoDeNotaFiscalRejeitarItemView.vue';
import RecebimentoDeNotaFiscalVincularPedidoModal from './RecebimentoDeNotaFiscalVincularPedidoView.vue';
import RecebimentoDeNotaFiscalImportXmlView from './RecebimentoDeNotaFiscalImportXmlView.vue';

/*==================================================================*/
/*==================== ALERTA EXCEDE A QUANTIDADE ==================*/
/*==================================================================*/

import AlertExedsQuantity from './AlertExedsQuantity.vue';

/*==================================================================*/
/*========================= UTILS DATE TIME ========================*/
/*==================================================================*/

import UtilDateTime from '@/utils/UtilDateTime.js';

/*==================================================================*/
/*============================ SERVICES ============================*/
/*==================================================================*/

import RecebimentoDeNotaFiscalService from '@/api/v2/services/RecebimentoDeNotaFiscalService.js';

/*==================================================================*/
/*=================== IMPORTS DO USUARIO ===========================*/
/*==================================================================*/

import useUsuarioStore from '@/api/v2/stores/UsuarioStore.js';
const usuarioStore = useUsuarioStore();

/*==================================================================*/
/*================= IMPORTS DO COLABORADOR =========================*/
/*==================================================================*/

import useColaboradorStore from '@/api/v2/stores/ColaboradorStore.js';
const colaboradorStore = useColaboradorStore();

export default {
    components: {
        // RecebimentoDeNotaFiscalBarcodeModal,
        RecebimentoDeNotaFiscalRejeitarItemModal,
        RecebimentoDeNotaFiscalVincularPedidoModal,
        RecebimentoDeNotaFiscalImportXmlView,
        AlertExedsQuantity
    },
    data() {
        return {
            isOpenAlertExedsQuantity: false,
            isImportXmlOpen: false,
            // isBarcodeModalOpen: false,
            isDeleteItemModalOpen: false,
            isSaving: false,
            isLocalDestinoDialogOpen: false,
            isVincularPedidoModalOpen: false,
            itemVinculado: '',
            pedidoCompra: '',
            pedidoCompraList: [],
            pedidoCompraOptions: [],
            itemVinculadoData: {},
            localDestinoMassa: null,
            deletedItem: [],
            selectedItem: [],
            itemsExedsQuantity: [],
            user: {},
            isFormValid: false,
            notaFiscal: {},
            actionsMassa: [
                // {
                //     title: 'Recusar em Massa',
                //     handle: () => {
                //         this.handleOpenDeleteItemModal(this.selectedItem)
                //     }
                // },
                {
                    title: 'Alterar Local de Destino em Massa',
                    handle: () => {
                        this.isLocalDestinoDialogOpen = true;
                    }
                },
            ],
            hoveredItem: '',
            notaFiscalConta: {},
            notaFiscalItems: [],
            localDestino: '',
            localOptions: [],
            itemToDelete: null,
            activeTab: 0,
            isModalOpen: false,
            searchText: '',
            item: [],
            rules: {
                required: v => !!v || "Campo obrigatório",
                min: v => v >= 0 || "Valor não pode ser negativo",
                max: v => v <= this.qty || `Máximo permitido é ${this.qty > 0 ? this.qty : 0}`
            },
            codigosBloqueados: [
                "9000000", "9100000", "9200000",
                "9300000", "9400000", "9500000",
                "9600000", "9700000", "9800000",
            ]
        };
    },
    computed: {
        pedidoCompraSelecionadoValido() {
            return !!this.pedidoCompra && this.pedidoCompraOptions.some(option => option.value === this.pedidoCompra);
        },
        linkedOsItemIds() {
            return this.notaFiscalItems
                .filter(item => item.osItem && item._id !== this.itemVinculado)
                .map(item => item.osItem._id);
        },
        selectableItemsCount() {
            return this.notaFiscalItems.filter(item => item.status === 'Pendente' && !item.naoAplicavel).length;
        },
        allItemsSelected() {
            return this.selectableItemsCount > 0 && this.selectedItem.length === this.selectableItemsCount;
        },
        someItemsSelected() {
            return this.selectedItem.length > 0 && !this.allItemsSelected;
        }
    },
    watch: {
        async pedidoCompra() {
            this.notaFiscalItems.forEach(item => {
                this.$set(item, 'osItem', null);
                this.$set(item, 'seqItemPurchaseOrder', null);
                this.$set(item, 'local', null);
            });

            await this.applyDefaultLocal();
        }
    },
    methods: {

        // handleBarcode(data) {
        //     this.searchText = data;
        //     this.isBarcodeModalOpen = false;
        //     this.getNF();
        // },

        // async setIsBarcodeModalOpen() {
        //     this.isBarcodeModalOpen = !this.isBarcodeModalOpen;
        // },

        setIsImportXmlOpen() {
            this.isImportXmlOpen = true;
        },

        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//

        //==================================================================//
        //========= RECEBE OS DADOS JÁ TRATADOS DO XML E FAZ MAGIA =========//
        //==================================================================//

        async importData(items, codNf, chaveAcesso, numPedido, serie, nfDataSaiEnt, nfTotals, natOp, emit_cnpj, emit_razao, dest_cnpj, dest_razao, modFrete, inf_Adic, qtd_Volumes, tipo_Volume, peso_KG) {

            try {
                //console.log('items AQUI >>> ', this.pedidoCompraOptions, nfDataSaiEnt, numPedido);

                this.pedidoCompra = numPedido;
                this.searchText = chaveAcesso;

                this.notaFiscalItems = items;
                this.notaFiscal.numero = codNf || '';
                this.notaFiscal.serie = serie;
                this.notaFiscal.dataSaida = nfDataSaiEnt;

                // Campos adicionais vindos do XML
                this.notaFiscal.natOp = natOp;
                this.notaFiscal.emit_cnpj = emit_cnpj;
                this.notaFiscal.emit_razao = emit_razao;
                this.notaFiscal.dest_cnpj = dest_cnpj;
                this.notaFiscal.dest_razao = dest_razao;

                // Transporte / informações adicionais
                this.notaFiscal.modFrete = modFrete;
                this.notaFiscal.inf_Adic = inf_Adic;
                this.notaFiscal.qtd_Volumes = qtd_Volumes;
                this.notaFiscal.tipo_Volume = tipo_Volume;
                this.notaFiscal.peso_KG = peso_KG;

                // Totais da NF vindos do XML (bloco <total>)
                if (nfTotals) {
                    this.notaFiscal.vlrFrete = nfTotals.vFrete ?? 0;
                    this.notaFiscal.vlrSeguro = nfTotals.vSeg ?? 0;
                    this.notaFiscal.valorProdutoTotal = nfTotals.vProd ?? 0;
                    this.notaFiscal.valorNotaFiscal = nfTotals.vNF ?? 0;
                    this.notaFiscal.valorDesconto = nfTotals.vDesc ?? 0;
                }

                const requestData = {
                    params: [
                        {
                            name: 'pedido',
                            dataType: 'String',
                            value: numPedido,
                        },
                    ],
                    viewName: 'recebimento-de-nota-fiscal-recebida-pega-pedido-de-compra-da-nota-fiscal-recebida',
                    page: 1,
                    limit: 1,
                };

                const response = await Vue.prototype.$http.post('/View/run', requestData);
                const itemsData = response?.data?.data?.data[0]?.itens || [];

                this.itemsExedsQuantity = [];
                const filteredItems = [];

                // console.log('notaFiscalItems >>> ', this.notaFiscalItems);
                // console.log('itemsData pedido >>> ', itemsData);

                console.log("####################################")

                console.log("PEDIDO DE COMPRA (Obtido da VIEW com base no que veio na Nota Fiscal Emitida)")
                console.log(response.data.data.data[0]);

                console.log("ITENS DO PEDIDO DE COMPRA (Obtido da VIEW com base no que veio na Nota Fiscal Emitida)")
                console.log(itemsData);

                console.log("####################################")

                // Para cada item da nota fiscal
                this.notaFiscalItems.forEach(async (nfItem, index) => {

                    console.log("####################################")

                    console.log("ITEM DA NOTA FISCAL EMITIDA (Obtido do XML com base no que veio na Nota Fiscal Emitida)")
                    // console.log(`Código do Pedido de Compra do Item: ${nfItem.codPurchaseOrder}`);
                    console.log(`Código do Item do Pedido de Compra: ${nfItem.seqItemPurchaseOrder}`);
                    console.log(nfItem);

                    console.log("####################################")

                    // Tenta encontrar o item correspondente no pedido
                    let osItem = itemsData.find(
                        (i) =>
                            i.pedidoDeCompraItemCodigo === nfItem.seqItemPurchaseOrder
                    );

                    console.log("####################################")

                    console.log("ITEM DA ORDEM DE SERVICO (Obtido ao Cruzar o Código do Item do Pedido de Compra no XML com o Código do Item do Pedido de Compra vindo da View)");
                    console.log("> Se ele não existir significa que não mandaram ele na Nota Fiscal Emitida");
                    console.log("> Tudo bem não existir, ele ainda pode ser vinculado manualmente");
                    console.log(osItem);

                    console.log("####################################")

                    if (osItem) {

                        // Valida excesso de quantidade
                        if (nfItem.qty > osItem.quantidadeCompra) {
                            this.itemsExedsQuantity.push(nfItem);
                        }

                        // Filtra apenas os itens válidos (independente da unidade)
                        if (nfItem.qty <= osItem.quantidadeCompra) {
                            filteredItems.push(nfItem);
                        }

                        // Atualiza campos com reatividade
                        this.$set(nfItem, 'descriptionItem', nfItem.descriptionItem);
                        this.$set(nfItem, 'quantidade', nfItem.qty);
                        this.$set(nfItem, 'qty', nfItem.qty);
                        this.$set(nfItem, 'quantidadeEntregue', nfItem.qty ?? 0);
                        this.$set(nfItem, 'osItem', osItem);
                        // this.$set(nfItem, 'codPurchaseOrder', osItem.codPurchaseOrder);
                        this.$set(nfItem, 'seqItemPurchaseOrder', osItem.pedidoDeCompraItemCodigo);

                    } else {
                        // Garante que pelo menos os itens importados apareçam na tela
                        this.$set(nfItem, 'quantidade', nfItem.quantidade ?? nfItem.qty);
                    }
                });

                // Se conseguiu vincular algum item ao pedido, usa apenas os filtrados;
                // caso contrário, mantém todos os itens importados.
                if (filteredItems.length > 0) {
                    // Remove duplicados pelo _id
                    this.notaFiscalItems = Array.from(
                        new Map(filteredItems.map((item) => [item._id, item])).values()
                    );
                } else {
                    this.notaFiscalItems = this.notaFiscalItems.map((item) => ({
                        ...item,
                        quantidade: item.quantidade ?? item.qty,
                    }));
                }

                await this.applyDefaultLocal();

                console.log('notaFiscalItems FINAL >>> ', this.notaFiscalItems);

                this.isImportXmlOpen = false;
                this.$notfy.success('Dados vinculados com sucesso!');

                if (this.itemsExedsQuantity.length > 0) {
                    this.isOpenAlertExedsQuantity = true;
                }
            } catch (error) {
                console.error('Erro ao importar dados:', error);
                this.$notfy.error('Erro ao importar dados da nota fiscal.');
            }
        },


        async handleOpenDeleteItemModal(itemId) {
            const isArray = Array.isArray(itemId)
            if (isArray) {
                this.deletedItem = itemId
            } else {
                this.deletedItem = [itemId]
            }
            this.isDeleteItemModalOpen = true
        },

        handleOpenVincularPedidoModal(item) {
            if (!this.pedidoCompraSelecionadoValido) {
                this.$notfy.error('Selecione um Pedido de Compra antes de vincular um item.');
                return;
            }
            this.itemVinculado = item._id;
            this.itemVinculadoData = item.osItem || null
            this.isVincularPedidoModalOpen = true;
        },

        handleLinkPedido(osItem, pedido) {
            const index = this.notaFiscalItems.findIndex(i => i._id === this.itemVinculado);
            if (index !== -1) {
                this.$set(this.notaFiscalItems[index], 'osItem', osItem);
                // this.$set(this.notaFiscalItems[index], 'codPurchaseOrder', pedido);
                this.$set(this.notaFiscalItems[index], 'seqItemPurchaseOrder', osItem.pedidoDeCompraItemCodigo);
                console.log(this.notaFiscalItems[index])
            }
            this.isVincularPedidoModalOpen = false;
            this.itemVinculado = ''; // opcional: limpa o estado
            this.itemVinculadoData = {};
        },

        handleUnlinkPedido(item) {
            const index = this.notaFiscalItems.findIndex(i => i._id === item._id);
            if (index !== -1) {
                this.$set(this.notaFiscalItems[index], 'osItem', null);
                this.$set(this.notaFiscalItems[index], 'seqItemPurchaseOrder', null);
            }
        },

        handleCloseVinculaPedidoModal() {
            this.itemVinculado = '';
            this.itemVinculadoData = {};
            this.isVincularPedidoModalOpen = false
        },

        isItemSelected(item) {
            return this.selectedItem.some(i => i._id === item._id);
        },

        toggleSelectAll(checked) {
            const selectableItems = this.notaFiscalItems.filter(item => item.status === 'Pendente' && !item.naoAplicavel);

            if (checked) {
                this.selectedItem = selectableItems;
            } else {
                this.selectedItem = [];
            }
        },

        onItemCheck(item) {
            const exists = this.selectedItem.find(i => i._id === item._id);
            if (!exists) {
                this.selectedItem.push(item);
            } else {
                this.selectedItem = this.selectedItem.filter(i => i._id !== item._id);
            }
        },

        toggleNaoAplicavel(item) {
            this.$set(item, 'naoAplicavel', !item.naoAplicavel);

            if (item.naoAplicavel) {
                this.selectedItem = this.selectedItem.filter(i => i._id !== item._id);

                if (item.osItem) {
                    this.handleUnlinkPedido(item);
                }
            }
        },

        aplicarLocalDestinoEmMassa() {
            if (!this.localDestinoMassa) return;

            this.selectedItem.forEach(item => {
                item.local = this.localDestinoMassa;
            });

            this.isLocalDestinoDialogOpen = false;
            this.localDestinoMassa = null;
        },

        async handleCloseDeleteItemModal() {
            this.deletedItem = []
            this.isDeleteItemModalOpen = false
            this.getNF();
        },

        async handleCancelDeleteItemModal() {
            this.deletedItem = []
            this.isDeleteItemModalOpen = false
            // this.getNF();
        },

        async applyDefaultLocal() {
            if (this.localOptions.length === 0) {
                await this.getLocalOptions();
            }

            const patio = this.localOptions.find(local => local.text?.trim().toLowerCase() === 'pátio');
            if (!patio) return;

            this.notaFiscalItems.forEach(item => {
                if (!item.local) {
                    this.$set(item, 'local', patio.id);
                }
            });
        },

        async getLocalOptions() {
            let reqLocal = await Vue.prototype.$http.get(`/Entity/StockLocal?limit=99999`);
            let local = reqLocal.data.data.data

            this.localOptions = [
                ...new Map(
                    local.map(locale => [locale.id, { text: locale.descricao, id: locale.id }])
                ).values()
            ].sort((a, b) => a.text.localeCompare(b.text));
        },

        async getNF() {

            let { data } = await Vue.prototype.$http.post('/View/run', {
                params: [
                    { dataType: "String", name: "chaveAcesso", value: this.searchText }
                ],
                viewName: "get-nf-recebimento",
                page: 1,
                limit: 1
            });
            const response = data?.data?.data[0]

            console.log("########################################");

            console.log("Nota Fiscal Recebida (Obtida ao se digitar a chave de acesso da Nota Fiscal) [Método: getNF]");
            console.log(response);

            console.log("########################################");

            if (!response) {
                this.notaFiscal = {};
                this.notaFiscalItems = [];
                this.notaFiscalConta = {};
                this.pedidoCompra = '';
                this.$notfy.error('Nenhuma Nota Fiscal encontrada para a chave de acesso informada.');
                return;
            }

            this.notaFiscal = response;
            this.notaFiscalItems = response.items.map(item => ({
                ...item,
                quantidade: item.qty,
                status: item.status || 'Pendente'
            }));

            console.log(this.notaFiscalItems);

            await this.applyDefaultLocal();

            this.notaFiscalConta = response.conta;

            const pedidoCompraSelecionado = this.pedidoCompraList.find(item => item.id === response.pedidoDeCompra || item.codigo === response.pedidoDeCompra);
            console.log(pedidoCompraSelecionado);

            this.pedidoCompra = pedidoCompraSelecionado?.codigo || ''

        },

        async capitalizeSelectedKeys(obj) {
            const keysToCapitalize = [
                'nCM',
                'cFOP',
                'cOFINSValor',
                'cOFINSPerc',
                'cOFINSBaseCalculo',
                'pISValor',
                'pISPerc',
                'pISBaseCalculo',
                'iPIValor',
                'iPIPercIPI',
                'iPIBaseCalculo',
                'iCMSValor',
                'iCMSPercICMS',
                'iCMSBaseCalculo'
            ];

            const result = {};

            for (const key in obj) {
                if (
                    Object.prototype.hasOwnProperty.call(obj, key) &&
                    obj[key] !== null &&
                    obj[key] !== undefined &&
                    obj[key] !== 'Empty'
                ) {
                    if (keysToCapitalize.includes(key)) {
                        const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                        result[capitalizedKey] = obj[key];
                    } else {
                        result[key] = obj[key];
                    }
                }
            }

            return result;
        },

        formatMoney(value) {
            return `R$ ${this.normalizeNumber(value).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        },

        normalizeNumber(value) {
            if (value === null || value === undefined || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            let parsed = String(value).trim();
            if (!parsed) return 0;

            if (parsed.includes(',') && parsed.includes('.')) {
                parsed = parsed.replace(/\./g, '').replace(',', '.');
            } else if (parsed.includes(',')) {
                parsed = parsed.replace(',', '.');
            }

            const numberValue = Number(parsed);
            return Number.isFinite(numberValue) ? numberValue : 0;
        },

        getTaxDisplayValue(item, taxName) {
            const unit = this.normalizeNumber(item?.vlrunit);

            if (taxName === 'ICMS') {
                const explicitValue = [item?.ICMSValor, item?.iCMSValor, item?.iCMSVlrICMS].find((v) => v !== null && v !== undefined && v !== '');
                if (explicitValue !== undefined) return this.normalizeNumber(explicitValue);
                return this.normalizeNumber(unit * (this.normalizeNumber(item?.iCMSPercICMS ?? item?.ICMSPercICMS) / 100));
            }

            if (taxName === 'PIS') {
                const explicitValue = [item?.PISValor, item?.pISValor, item?.pISVlrPIS].find((v) => v !== null && v !== undefined && v !== '');
                if (explicitValue !== undefined) return this.normalizeNumber(explicitValue);
                return this.normalizeNumber(unit * (this.normalizeNumber(item?.pISPerc ?? item?.PISPerc) / 100));
            }

            if (taxName === 'COFINS') {
                const explicitValue = [item?.COFINSValor, item?.cOFINSValor, item?.cOFINSVlrCOFINS].find((v) => v !== null && v !== undefined && v !== '');
                if (explicitValue !== undefined) return this.normalizeNumber(explicitValue);
                return this.normalizeNumber(unit * (this.normalizeNumber(item?.cOFINSPerc ?? item?.COFINSPerc) / 100));
            }

            return 0;
        },

        getValorRealDisplay(item) {
            const unit = this.normalizeNumber(item?.vlrunit);
            const icms = this.getTaxDisplayValue(item, 'ICMS');
            const pis = this.getTaxDisplayValue(item, 'PIS');
            const cofins = this.getTaxDisplayValue(item, 'COFINS');
            const explicitValorReal = item?.valorReal ?? item?.ValorReal;

            if (explicitValorReal !== null && explicitValorReal !== undefined && explicitValorReal !== '') {
                return Math.max(0, this.normalizeNumber(explicitValorReal));
            }

            return Math.max(0, this.normalizeNumber(unit - cofins - pis - icms));
        },

        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//

        async aoSalvarNotaFiscalRecebida() {

            //==================================================================//
            //========================== FORM VALIDATE =========================//
            //==================================================================//

            if(!this?.$refs?.form?.validate()){
                return;
            }

            //==================================================================//
            //==================== BLOQUEIA O INPUT NA TELA ====================//
            //==================================================================//

            this.isSaving = true;

            //==================================================================//
            //==================== CONSOLE NOTA FISCAL ITENS ===================//
            //==================================================================//
        
            console.log("Ao Salvar Nota Fiscal Recebida");
            console.log(this.notaFiscalItems);

            //==================================================================//
            //================== ITERA OS ITENS DA NOTA FISCAL =================//
            //==================================================================//

            let i = 0;
            for(const item of this.notaFiscalItems){

                console.log("TESTE");
                console.log(item);

                i += 1;

                //==================================================================//
                //============== IGNORA ITEM MARCADO COMO NÃO APLICÁVEL ============//
                //==================================================================//

                if (item.naoAplicavel) {
                    continue;
                }

                //==================================================================//
                //===================== PEGA O SALDO DE ESTOQUE ====================//
                //==================================================================//
                // BUG: O CÓDIGO NÃO TRATA O CASO DE NÃO TER CLICADO PARA VINCULAR OS ITENS, SE VINCULOU OU NÃO ELE TENTA RODAR
                // SE FALHAR SEGUE EM FRENTE E CONTINUA COM O ERRO.

                const reqDestino = await Vue.prototype.$http.get(
                    `/Entity/StockBalance/search-fields?value=[${item.osItem.item._id}],[${item.local}]&searchFields=[item],[localEstoque]`
                );

                const localEstoqueDestinoDescricao = this.localOptions.find(local => local.id === item.local)?.text;

                const destinoData = reqDestino?.data?.data?.data[0];
                const destinoEntityId = destinoData?.id || destinoData?._id || null;
                const destinoExists = reqDestino.data.data.total > 0 && !!destinoEntityId;

                const cleanDestino = destinoExists
                    ? (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => ({
                        ...rest,
                        id: destinoEntityId
                    }))(destinoData)
                    : null;


                console.log(reqDestino);

                //==================================================================//
                //====== DEPENDENDO DE EXISTIR O SALDO DE ESTOQUE FAÇA ALGO ========//
                //==================================================================//

                if (destinoExists) { //====== SE O SALDO DE ESTOQUE EXISTIR ========//

                    //==================================================================//
                    //=========== NORMALIZA OS CAMPOS DE SALGO DE ESTOQUE ==============//
                    //==================================================================//

                    const unit = this.normalizeNumber(item.vlrunit);
                    const quantidade = this.normalizeNumber(item.quantidade);

                    // Joseph: Quando for Receber para um SALDO DE ESTOQUE já existe.
                    const saldoDeEstoqueExistenteQuantidadeTotal = this.normalizeNumber(cleanDestino.quantidadeTotal);
                    const saldoDeEstoqueExistenteQuantidadeReservada = this.normalizeNumber(cleanDestino.quantidadeTotal);

                    const totalQuantidade = saldoDeEstoqueExistenteQuantidadeTotal + quantidade; // Joseph: Some ao Total a Quantidade Recebida na Nota Fiscal Recebida. 
                    const quantidadeReservada = saldoDeEstoqueExistenteQuantidadeReservada + quantidade; // Joseph: Some ao Reservado a Quantidade Recebida na Nota Fiscal Recebida.

                    const valorMedio = totalQuantidade > 0 ? this.normalizeNumber((unit * totalQuantidade) / totalQuantidade) : 0;
                    const ICMSValor = this.getTaxDisplayValue(item, 'ICMS');
                    const PISValor = this.getTaxDisplayValue(item, 'PIS');
                    const COFINSValor = this.getTaxDisplayValue(item, 'COFINS');
                    const valorReal = this.getValorRealDisplay(item);

                    console.table({
                        unit,
                        quantidade,
                        totalQuantidade,
                        quantidadeReservada,
                        valorMedio,
                        ICMSValor,
                        PISValor,
                        COFINSValor,
                        valorReal,
                    });

                    //==================================================================//
                    //=================== ALTERA O SALDO DE ESTOQUE ====================//
                    //==================================================================//

                    console.log(cleanDestino);

                    await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                        ...cleanDestino,
                        id: cleanDestino.id,
                        quantidadeTotal: totalQuantidade,
                        quantidadeReservado: quantidadeReservada,
                        valorTotal: this.normalizeNumber(unit * totalQuantidade),
                        valorMedio: !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? valorMedio : 0,
                        valorReal: valorReal,
                        ICMSValor: ICMSValor,
                        PISValor: PISValor,
                        COFINSValor: COFINSValor,
                        IBSValor: Number(item.IBSValor || 0) || undefined,
                        CBSValor: Number(item.CBSValor || 0) || undefined,
                        CSOSNValor: item.CSOSNValor || '101',
                        dataAlteracao: UtilDateTime.todayUTC(),
                    });

                    //==================================================================//
                    //===== PEGA CODIGO AUTO INC DO HISTORICO DO SALGO DE ESTOQUE ======//
                    //==================================================================//

                    const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                        "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                    );

                    const saldoDeEstoqueId = cleanDestino?.id || cleanDestino?._id;

                    //==================================================================//
                    //============= CRIA O HISTÓRICO DO SALDO DE ESTOQUE ===============//
                    //==================================================================//

                    console.log(this.notaFiscal);

                    await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                        "codigo": newCodigoHistoricoOrigem.data,
                        "tipo": 'Entrada',
                        "descricao": `RECEBIMENTO DE NOTA FISCAL N°${this.notaFiscal.numero} PARA ${localEstoqueDestinoDescricao}`,
                        "dataMovimentacao": UtilDateTime.todayUTC(),
                        "quantidade": Number(item.quantidade),
                        "colaboradorDaMovimentacao": colaboradorStore?.colaborador?.id,
                        "saldoDeEstoque": saldoDeEstoqueId,
                        "item": item.osItem.item._id,
                        "notaFiscalRecebida": this.notaFiscal._id,
                        "os": item.osItem.ordemDeServico._id,
                        "osItem": item.osItem._id,
                        "job": item.osItem.ordemDeServico.job._id,
                        "ICMSValor": ICMSValor,
                        "PISValor": PISValor,
                        "COFINSValor": COFINSValor,
                        "IBSValor": Number(item.IBSValor || 0) || undefined,
                        "CBSValor": Number(item.CBSValor || 0) || undefined,
                        "CSOSNValor": item.CSOSNValor || '101',
                    });

                    //==================================================================//
                    //============= NOTIFICA OPERACAO REALIZADA COM SUCESSO ============//
                    //==================================================================//

                    this.$notfy.success(`Saldo de Estoque alterado com sucesso ! (Item ${item.seqitem} - NF)`);

                } else { //====== SE O SALDO DE ESTOQUE NÃO EXISTIR ========//

                    //==================================================================//
                    //========== PEGA CODIGO AUTO INC DO SALDO DE ESTOQUE ==============//
                    //==================================================================//

                    const newCodigo = await Vue.prototype.$http.get(
                        "/Entity/AutoInc?schemaName=StockBalance&field=codigo&mask=######"
                    );

                    //==================================================================//
                    //=========== NORMALIZA OS CAMPOS DE SALGO DE ESTOQUE ==============//
                    //==================================================================//

                    const unit = this.normalizeNumber(item.vlrunit);
                    const quantidade = this.normalizeNumber(item.quantidade);
                    const ICMSValor = this.getTaxDisplayValue(item, 'ICMS');
                    const PISValor = this.getTaxDisplayValue(item, 'PIS');
                    const COFINSValor = this.getTaxDisplayValue(item, 'COFINS');
                    const valorReal = this.getValorRealDisplay(item);

                    console.table({
                        unit,
                        quantidade,
                        ICMSValor,
                        PISValor,
                        COFINSValor,
                        valorReal
                    });

                    //==================================================================//
                    //=================== CRIA O SALDO DE ESTOQUE ======================//
                    //==================================================================//

                    const newOrigem = await Vue.prototype.$http.post(`/Entity/StockBalance`, {
                        codigo: newCodigo.data,
                        item: item.osItem.item._id,
                        localEstoque: item.local,
                        valorMedio: !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? (quantidade > 0 ? this.normalizeNumber((unit * quantidade) / quantidade) : 0) : 0,
                        valorTotal: this.normalizeNumber(unit * quantidade),
                        valorReal: valorReal,
                        quantidadeTotal: quantidade, // Joseph: A quantidade total SEMPRE será IGUAL a quantidade que foi Recebida na Nota Fiscal Recebida.
                        quantidadeDisponivel: 0, // Joseph: A quantidade disponivel SEMPRE será 0 pois eu já dou entrada no sistema Reservando eles.
                        quantidadeReservado: quantidade, // Joseph: A quantidade reservada SEMPRE será IGUAL a quantidade que foi Recebida na Nota Fiscal Recebida.
                        ICMSValor: ICMSValor,
                        PISValor: PISValor,
                        COFINSValor: COFINSValor,
                        IBSValor: Number(item.IBSValor || 0),
                        CBSValor: Number(item.CBSValor || 0),
                        CSOSNValor: item.CSOSNValor || '101',
                        dataAlteracao: UtilDateTime.todayUTC()
                    });

                    console.log(newOrigem);

                    //==================================================================//
                    //===== PEGA CODIGO AUTO INC DO HISTORICO DO SALGO DE ESTOQUE ======//
                    //==================================================================//

                    const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                        "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                    );

                    //==================================================================//
                    //============= CRIA O HISTÓRICO DO SALDO DE ESTOQUE ===============//
                    //==================================================================//

                    console.log(this.notaFiscal);

                    await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                        "codigo": newCodigoHistoricoOrigem.data,
                        "tipo": 'Entrada',
                        "descricao": `RECEBIMENTO DE NOTA FISCAL N°${this.notaFiscal.numero} PARA ${localEstoqueDestinoDescricao}`,
                        "dataMovimentacao": UtilDateTime.todayUTC(),
                        "quantidade": Number(item.quantidade),
                        "colaboradorDaMovimentacao": colaboradorStore?.colaborador?.id,
                        "saldoDeEstoque": newOrigem.data.data.id,
                        "item": item.osItem.item._id,
                        "notaFiscalRecebida": this.notaFiscal._id,
                        "os": item.osItem.ordemDeServico._id,
                        "osItem": item.osItem._id,
                        "job": item.osItem.ordemDeServico.job._id,
                        "ICMSValor": ICMSValor,
                        "PISValor": PISValor,
                        "COFINSValor": COFINSValor,
                        "IBSValor": Number(item.IBSValor || 0),
                        "CBSValor": Number(item.CBSValor || 0),
                        "CSOSNValor": item.CSOSNValor || '101',
                    });

                    //==================================================================//
                    //============= NOTIFICA OPERACAO REALIZADA COM SUCESSO ============//
                    //==================================================================//

                    this.$notfy.success(`Saldo de Estoque gerado com sucesso ! (Item ${item.seqitem} - NF)`);

                }

                //==================================================================//
                //=========== DESCONSTRUTOR DE CAMPOS ESTRANHO - NAO MEXER =========//
                //==================================================================//

                const {
                    _id,
                    updateAt,
                    updateBy,
                    deleteAt,
                    deleteBy,
                    isDeleted,
                    pedidoDeCompra,
                    operacaoFiscal,
                    quantidade,
                    local,
                    nfIndustrializacao,
                    osItem,
                    item: nestedItem,
                    ...rest
                } = item;

                const {
                    updateAt: updateAtOs,
                    updateBy: updateByOs,
                    deleteAt: deleteAtOs,
                    deleteBy: deleteByOs,
                    destino,
                    isDeleted: isDeleteOs,
                    ordemDeServico,
                    _id: idOs,
                    ...osRest
                } = osItem;

                //==================================================================//
                //======== REALIZA RECEBIMENTO DE NOTA FISCAL EMITIDA ==============//
                //==================================================================//
                // Por hora, faz meio processo, apenas o de Ordem de Serviço

                let ordemDeServicoItemValores = {
                    id: item?.osItem?._id || "",
                    quantidadeRecebendo: item?.quantidade || 0,
                }

                // Chama a service para realizar o Recebimento de Nota Fiscal Emitida.
                let response = await RecebimentoDeNotaFiscalService.realizarRecebimentoDeNotaFiscalRecebida(ordemDeServicoItemValores);
                if(response?.status != 200) {
                    this.$notfy.error('Falha ao criar o Recebimento de Nota Fiscal.');
                    throw new Error("Falha ao criar o Recebimento de Nota Fiscal");
                }

                //==================================================================//
                //======== REALIZA RECEBIMENTO DE NOTA FISCAL EMITIDA ==============//
                //==================================================================//

                const reqItem = await Vue.prototype.$http.get(
                    `/Entity/FisDocRecItem/search-fields?ids=${item._id},`
                );

                const reqItemData = reqItem?.data?.data?.data[0]

                if (reqItemData) {
                    const {
                        updateAt: updateAtItem,
                        updateBy: updateByItem,
                        deleteAt: deleteAtItem,
                        deleteBy: deleteByItem,
                        isDeleted: isDeleteItem,
                        ...restItem
                    } = reqItemData;

                    const noNullValuesRestItem = Object.fromEntries(
                        Object.entries(restItem).filter(([_, v]) => v !== null && v !== undefined)
                    );

                    await Vue.prototype.$http.put(`/Entity/FisDocRecItem`, {
                        ...noNullValuesRestItem,
                        ...(nfIndustrializacao && nfIndustrializacao.length > 0
                            ? { nfIndustrializacao: Array.isArray(nfIndustrializacao) ? nfIndustrializacao.join(',') : nfIndustrializacao }
                            : {}),
                        pedidoDeCompraItem: item?.osItem?.pedidoDeCompraItemID || "",
                    });

                }

                //==================================================================//
                //======== BUSCA A NOTA FISCAL RECEBIDA PELA CHAVE DE ACESSO =======//
                //==================================================================//

                const reqNF = await Vue.prototype.$http.get(
                    `/Entity/FisDocRec/search-fields?value=${this.searchText}&searchFields=chaveAcesso&mode=Equals`
                );

                const NFData = reqNF?.data?.data?.data[0];

                console.log('NFData >>> ', NFData)
                console.log('notaFiscalItems >>> ', this.notaFiscalItems)

                //==================================================================//
                //=========== DEPENDENDO SE EXISTE A NOTA FISCAL RECEBIDA ==========//
                //==================================================================//

                if(NFData){ //=== SE A NOTA FISCAL JA EXISTE NO SISTEMA ===//

                    const cleanNF = (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => rest)(NFData)

                    await Vue.prototype.$http.put(`/Entity/FisDocRec`, {
                        ...cleanNF,
                        status: 'Recebida'
                    });

                }else{ //=== SE A NOTA FISCAL NÃO EXISTE NO SISTEMA ===//

                    await this.criaNotaFiscalRecebida();

                }

            }

            //==================================================================//
            //=========== NOTIFICA QUE A NOTA FISCAL FOI RECEBIDA ==============//
            //==================================================================//

            await this.getNF();
            this.$notfy.success('A Nota Fiscal Recebida foi recebida com sucesso.');

            // Vue.prototype.$notify({
            //     title: "Nota Recebida com Sucesso!",
            //     closeOnClick: true,
            //     duration: 3000,
            //     positions: "right",
            //     type: "success",
            // });

            //==================================================================//
            //=================== DESBLOQUEIA O INPUT NA TELA ==================//
            //==================================================================//

            this.isSaving = false;

        },

        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//

        async getPurchaseOrderOptions() {
            const req = await Vue.prototype.$http.get(`/Entity/PedidoDeCompra/search-fields?limit=99999&page=1`);
            const data = req?.data?.data?.data;
            this.pedidoCompraList = data;
            const options = data.map(order => ({
                text: order.codigo,
                value: order.codigo
            }))
            this.pedidoCompraOptions = options
        },

        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//

        async criaNotaFiscalRecebida() {

            console.log("notaFiscalItems >>> ", this.notaFiscalItems);

            //==================================================================//
            //============== PREPARA ITENS DA NOTA FISCAL RECEBIDA =============//
            //==================================================================//

            const finDocRecItem = this.notaFiscalItems.map((nfItem) => {

                const quantidade = Number(nfItem.quantidade ?? 0);

                return {
                    seqitem: nfItem.seqitem,

                    pedidoDeCompraItem: nfItem?.osItem?.pedidoDeCompraItemID || "",
                    
                    descriptionItem: nfItem.descriptionItem,
                    qty: quantidade.toString(),

                    vlrunit: Number(nfItem.vlrunit ?? 0).toFixed(2),
                    vlrtotal: Number(nfItem.vlrtotal ?? 0).toFixed(2),

                    ICMSBaseCalculo: Number(nfItem.icmsValorBaseCalculo ?? 0).toFixed(2),
                    ICMSPercICMS: Number(nfItem.iCMSPercICMS ?? 0).toFixed(2),
                    ICMSValor: Number(nfItem.iCMSVlrICMS ?? 0).toFixed(2),

                    IPIBaseCalculo: Number(nfItem.ipiValorBaseCalculo ?? 0).toFixed(2),
                    IPIPercIPI: nfItem.iPIPercIPI?.toString(),
                    IPIValor: Number(nfItem.iPIVlrIPI ?? 0).toFixed(2),

                    PISBaseCalculo: Number(nfItem.pISBaseCalculo ?? 0).toFixed(2),
                    PISPerc: nfItem.pISPerc?.toString(),
                    PISValor: Number(nfItem.pISVlrPIS ?? 0).toFixed(2),

                    COFINSBaseCalculo: Number(nfItem.cofinsBaseCalculo ?? 0).toFixed(2),
                    COFINSPerc: nfItem?.cOFINSPerc?.toString(),
                    COFINSValor: Number(nfItem.cOFINSVlrCOFINS ?? 0).toFixed(2),

                    valorIBS: Number(nfItem.IBSValor ?? 0).toFixed(2),
                    valorCBS: Number(nfItem.CBSValor ?? 0).toFixed(2),

                    cfop: nfItem.cfop,
                    ncm: nfItem.ncm,

                };
            });

            console.log("finDocRecItem >>> ", finDocRecItem);

            //==================================================================//
            //=============== CRIA ITENS DA NOTA FISCAL RECEBIDA ===============//
            //==================================================================//

            // Insert dos itens
            const response = await Vue.prototype.$http.post(
                "/Entity/insertMany/FisDocRecItem",
                finDocRecItem
            );

            const itensFinDocRec = response.data.data;

            //==================================================================//
            //=================== CRIA NOTA FISCAL RECEBIDA ====================//
            //==================================================================//

            // Insert do documento pai
            await Vue.prototype.$http.post("/Entity/FisDocRec", {
                porjectId: this.notaFiscalItems[0].osItem.ordemDeServico.job._id,
                osId: this.notaFiscalItems[0].osItem.ordemDeServico._id,
                pedidoDeCompra: this.pedidoCompraList.filter(item => item.codigo === this.pedidoCompra)[0].id,
                item: this.notaFiscalItems[0].osItem.item._id,
                companySiteId: "c511a33d-6b85-4cdf-88af-6a221f0eb46d",
                serie: this.notaFiscal.serie,
                numero: this.notaFiscal.numero,
                chaveAcesso: this.searchText,
                natOp: this.notaFiscal.natOp,
                emit_cnpj: this.notaFiscal.emit_cnpj,
                emit_razao: this.notaFiscal.emit_razao,
                dest_cnpj: this.notaFiscal.dest_cnpj,
                dest_razao: this.notaFiscal.dest_razao,
                dataCriacao: UtilDateTime.todayUTC(),
                dataEmissao: new Date(this.notaFiscalItems[0].dataEmissao),
                dataES: new Date(this.notaFiscal.dataSaida),
                vlrFinanceiro: Number(this.notaFiscalItems.reduce((acc, item) => acc + Number(item.vlrtotal ?? 0), 0).toFixed(2)),
                vlrBC: Number(itensFinDocRec.reduce((acc, item) => acc + Number(item.ICMSBaseCalculo ?? 0), 0).toFixed(2)),
                fisDocRecItemS: itensFinDocRec.map((item) => item.id),
                vlrIPI: Number(itensFinDocRec.reduce((acc, item) => acc + Number(item.IPIValor ?? 0), 0).toFixed(2)),
                vlrICMS: Number(itensFinDocRec.reduce((acc, item) => acc + Number(item.ICMSValor ?? 0), 0).toFixed(2)),
                vlrPIS: Number(itensFinDocRec.reduce((acc, item) => acc + Number(item.PISValor ?? 0), 0).toFixed(2)),
                vlrCOFINS: Number(itensFinDocRec.reduce((acc, item) => acc + Number(item.COFINSValor ?? 0), 0).toFixed(2)),
                valorCBS: Number(this.notaFiscalItems.reduce((acc, item) => acc + Number(item.CBSValor ?? 0), 0).toFixed(2)),
                valorIBS: Number(this.notaFiscalItems.reduce((acc, item) => acc + Number(item.IBSValor ?? 0), 0).toFixed(2)),
                // Totais da NF vindos do XML (bloco <total>)
                valorProduto: Number(this.notaFiscal.valorProdutoTotal ?? 0),
                valorOriginal: Number(this.notaFiscal.valorNotaFiscal ?? 0),
                valorParaReservar: Number(this.notaFiscal.valorNotaFiscal ?? 0),
                valorDesconto: Number(this.notaFiscal.valorDesconto ?? 0),
                valorPagamento: Number(this.notaFiscalItems.reduce((acc, item) => acc + Number(item.vlrTotal ?? 0), 0).toFixed(2)),
                valorReservado: Number(this.notaFiscalItems.reduce((acc, item) => acc + Number(item.vlrTotal ?? 0), 0).toFixed(2)),
                valorPago: 0,

                vlrFrete: Number(this.notaFiscal.vlrFrete ?? 0),
                vlrSeg: Number(this.notaFiscal.vlrSeguro ?? 0),
                //modFrete: this.notaFiscal.modFrete,
                inf_Adic: this.notaFiscal.inf_Adic,
                qtd_Volumes: this.notaFiscal.qtd_Volumes,
                tipo_Volume: this.notaFiscal.tipo_Volume,
                peso_KG: String(this.notaFiscal.peso_KG) || '0',
                status: 'Recebida'
            });

        }

        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//
        //*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*//

    },
    created() {
        this.getLocalOptions();
        this.getPurchaseOrderOptions();
    }
};

</script>

<template>

    <v-container>
        
        <v-container
            style="display: flex; justify-content: space-between;"
        >

            <h2>Recebimento de Nota Fiscal</h2>

        </v-container>

        <v-container 
            class="d-flex flex-column flex-md-row justify-space-between pt-2"
            style="background-color: transparent; gap: 24px;" 
        >

            <div 
                class="d-flex"
                style="width: 100%; gap: 4px;"
            >

                <v-text-field
                    v-model="searchText"
                    label="Chave de Acesso"
                    dense
                    outlined
                    disabled
                />

                <!-- Recebimento por Chave de Acesso ainda em desenvolvimento -->
                <!-- <v-btn
                    style="box-shadow: none; margin: 0px 1px; background-color: blue; color: white !important;"
                    @click="getNF"
                    height="40"
                    :disabled="!searchText"
                >

                    <v-icon>mdi-magnify</v-icon>

                </v-btn> -->

                <!-- <v-btn
                    style="box-shadow: none; margin: 0px 0px; background-color: blue; color: white !important;"
                    height="40"
                    @click="setIsBarcodeModalOpen" 
                >

                    <v-icon>mdi-barcode</v-icon>

                </v-btn> -->
                
                <v-btn 
                    @click="setIsImportXmlOpen" 
                    style="box-shadow: none; margin: 0px 0px; background-color: blue; color: white !important;"
                    height="40"
                    
                >
                    <v-icon>
                        mdi-xml
                    </v-icon>

                </v-btn>

            </div>

            <div 
                class="d-flex justify-end gx-4"
            >

                <v-menu>

                    <template v-slot:activator="{ on }">

                        <v-btn 
                            style="background-color: blue; color: white !important;"
                            v-on="on"
                            height="40"
                            :disabled="selectedItem.length == 0 || isSaving"
                        >
                            Ações
                        </v-btn>

                    </template>

                    <v-list>

                        <v-list-item
                            v-for="(item, index) in actionsMassa"
                            class="cursor-pointer"
                            :key="index"
                            :value="index"
                            @click="item.handle" 
                            
                        >

                            <v-list-item-title>
                                {{ item.title }}
                            </v-list-item-title>

                        </v-list-item>

                    </v-list>

                </v-menu>

                <v-btn
                    :disabled="notaFiscalItems.length == 0 ||
                    !notaFiscalItems.every(item => item.status !== 'Pendente' || item.naoAplicavel || (item.osItem && item.local)) ||
                    isSaving"
                    height="40"
                    style="box-shadow: none; background-color: blue; color: white !important; margin: 0px 2px;"
                    @click="aoSalvarNotaFiscalRecebida">
                    Salvar

                    <v-icon 
                        style="padding-left: 4px; color: white !important;"
                    >
                        mdi-content-save
                    </v-icon>

                </v-btn>

            </div>

        </v-container>

        <v-container 
            v-if="notaFiscal"
            class="d-flex flex-column"
            style="gap: 16px;"
        >

            <v-card class="nf-info-card">

                <div class="nf-info-header">

                    <div class="nf-info-nf">
                        <span class="nf-field-label">NF</span>
                        <span class="nf-info-nf-value">{{ notaFiscal?.numero }}</span>
                    </div>

                    <div class="nf-field">
                        <span class="nf-field-label">Chave de Acesso</span>
                        <span class="nf-field-value nf-info-chave">{{ searchText }}</span>
                    </div>

                    <div class="nf-field">
                        <span class="nf-field-label">Fornecedor</span>
                        <span class="nf-field-value">{{ notaFiscal?.emit_razao || notaFiscalConta?.name || '-' }}</span>
                    </div>

                    <v-autocomplete
                        v-if="notaFiscalItems.length > 0 && notaFiscalItems.every(item => item.status === 'Pendente')"
                        v-model="pedidoCompra"
                        :items="pedidoCompraOptions"
                        label="Pedido de Compra"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        hide-details
                        class="nf-info-pedido"
                    />

                    <div
                        v-else-if="notaFiscalItems.length > 0"
                        class="nf-field"
                    >
                        <span class="nf-field-label">Pedido de Compra</span>
                        <span class="nf-field-value">{{ pedidoCompra }}</span>
                    </div>

                </div>

            </v-card>

            <div
                v-if="selectableItemsCount > 0"
                class="nf-select-all"
            >

                <v-checkbox
                    :input-value="allItemsSelected"
                    :indeterminate="someItemsSelected"
                    @change="toggleSelectAll"
                    class="ma-0 pa-0"
                    hide-details
                />

                <span>Selecionar Todos</span>

            </div>

            <v-form
                ref="form"
                v-model="isFormValid"
            >

                <v-card
                    v-for="(item, i) in notaFiscalItems"
                    :key="i"
                    class="nf-item-card"
                    :class="{
                        'red darken-2 white--text': item.status === 'Recusado',
                        'green darken-2 white--text': item.status === 'Recebido',
                        'yellow darken-3 white--text': item.status === 'Recebido_Parcialmente'
                    }"
                >

                    <div
                        v-if="item.osItem"
                        class="nf-item-badge"
                    >
                        Item Vinculado
                    </div>

                    <div class="nf-item-header">
                        <v-checkbox
                            v-if="item.status === 'Pendente' && !item.naoAplicavel"
                            :input-value="isItemSelected(item)"
                            @change="onItemCheck(item)"
                            class="ma-0 pa-0 nf-item-checkbox"
                            hide-details
                        />

                        <div class="nf-item-title">
                            <span class="nf-item-title-tag">Item {{ item.seqitem }} - NF</span>
                            <span class="nf-item-title-desc">{{ item.descriptionItem }}</span>
                        </div>
                    </div>

                    <div class="nf-item-fields">

                        <div
                            v-if="item.seqItemPurchaseOrder"
                            class="nf-field"
                        >
                            <span class="nf-field-label">Item do Pedido de Compra Vinculado</span>
                            <span class="nf-field-value">{{ item.seqItemPurchaseOrder }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Quantidade</span>
                            <span class="nf-field-value">{{ item.qty }}</span>
                        </div>

                        <!-- <div class="nf-field">
                            <span class="nf-field-label">Quantidade Recebida</span>
                            <span class="nf-field-value">{{ item.qtyReceived || 0 }}</span>
                        </div> -->

                        <div class="nf-field">
                            <span class="nf-field-label">Valor Unitário</span>
                            <span class="nf-field-value">{{ formatMoney(item.vlrunit) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor Real</span>
                            <span class="nf-field-value">{{ formatMoney(getValorRealDisplay(item)) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor ICMS</span>
                            <span class="nf-field-value">{{ formatMoney(getTaxDisplayValue(item, 'ICMS')) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor PIS</span>
                            <span class="nf-field-value">{{ formatMoney(getTaxDisplayValue(item, 'PIS')) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor COFINS</span>
                            <span class="nf-field-value">{{ formatMoney(getTaxDisplayValue(item, 'COFINS')) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor IBS</span>
                            <span class="nf-field-value">{{ formatMoney(item.IBSValor) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">Valor CBS</span>
                            <span class="nf-field-value">{{ formatMoney(item.CBSValor) }}</span>
                        </div>

                        <div class="nf-field">
                            <span class="nf-field-label">CSOSN</span>
                            <span class="nf-field-value">{{ item.CSOSNValor || 101 }}</span>
                        </div>

                        <div
                            v-if="item.status != 'Pendente'"
                            class="nf-field"
                        >
                            <span class="nf-field-label">N° NF Industrialização</span>
                            <span class="nf-field-value">{{ item.nfIndustrializacao }}</span>
                        </div>

                    </div>

                    <div
                        v-if="item.status === 'Pendente'"
                        class="nf-item-actions"
                    >

                        <div class="nf-item-actions-row">

                            <v-autocomplete
                                v-model="item.local"
                                :items="localOptions"
                                :disabled="item.naoAplicavel"
                                label="Local Destino"
                                item-text="text"
                                item-value="id"
                                dense
                                outlined
                                hide-details
                                class="nf-item-actions-field"
                            ></v-autocomplete>

                            <v-text-field
                                data-action-nfremessa
                                name="nfRemessa"
                                label="N° NF Industrialização"
                                v-model="item.nfIndustrializacao"
                                :disabled="item.naoAplicavel"
                                dense
                                outlined
                                hide-details
                                class="nf-item-actions-field"
                            ></v-text-field>

                        </div>

                        <div class="nf-item-actions-row nf-item-actions-row--end">

                            <v-btn
                                v-if="!item.osItem"
                                :disabled="item.naoAplicavel"
                                @click="handleOpenVincularPedidoModal(item)"
                                color="blue"
                                dark
                                depressed
                                class="nf-item-actions-btn"
                            >
                                Vincular Item
                            </v-btn>

                            <v-btn
                                v-else
                                :disabled="item.naoAplicavel"
                                @click="handleUnlinkPedido(item)"
                                color="red"
                                dark
                                depressed
                                class="nf-item-actions-btn"
                            >
                                Desvincular
                            </v-btn>

                            <v-btn
                                @click="toggleNaoAplicavel(item)"
                                color="purple darken-1"
                                :outlined="!item.naoAplicavel"
                                :dark="item.naoAplicavel"
                                depressed
                                class="nf-item-actions-btn"
                            >
                                Não Aplicável
                            </v-btn>

                        </div>

                    </div>

                </v-card>

            </v-form>

        </v-container>
        
        <v-dialog v-model="isLocalDestinoDialogOpen" max-width="500px">

            <v-card>

                <v-card-title>Alterar Local de Destino</v-card-title>

                <v-card-text>

                    <v-autocomplete 
                        v-model="localDestinoMassa"
                        :items="localOptions"
                        label="Selecione o local"
                        item-text="text"
                        item-value="id"
                        dense
                        outlined
                    />

                </v-card-text>

                <v-card-actions
                    class="justify-end"
                >

                    <v-btn 
                        text
                        @click="isLocalDestinoDialogOpen = false"
                    >
                        Cancelar
                    </v-btn>

                    <v-btn 
                        color="primary"
                        @click="aplicarLocalDestinoEmMassa"
                    >
                        Aplicar
                    </v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

        <RecebimentoDeNotaFiscalImportXmlView 
            :open="isImportXmlOpen" 
            @confirm="importData"
            @close="isImportXmlOpen = false"
        />

        <!-- <RecebimentoDeNotaFiscalBarcodeModal 
            :openCamera="isBarcodeModalOpen" 
            @barcode="handleBarcode"
        /> -->
        
        <RecebimentoDeNotaFiscalRejeitarItemModal 
            @close="handleCloseDeleteItemModal"
            @cancel="handleCancelDeleteItemModal" 
            :nfItens="deletedItem"
            :value="isDeleteItemModalOpen"
        />
        
        <RecebimentoDeNotaFiscalVincularPedidoModal
            @close="handleCloseVinculaPedidoModal"
            @link="handleLinkPedido"
            :linkedItem="itemVinculadoData"
            :linkedOsItemIds="linkedOsItemIds"
            :pedidoCompra="pedidoCompra"
            :value="isVincularPedidoModalOpen"
        />
        
        <AlertExedsQuantity 
            :isOpen="isOpenAlertExedsQuantity" 
            :itemsExedsQuantity="itemsExedsQuantity"
            @close="isOpenAlertExedsQuantity = false"
        />

    </v-container>

</template>

<style scoped>

.nf-info-card {
    padding: 16px 20px;
}

.nf-info-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
}

.nf-info-nf {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.nf-info-nf-value {
    font-size: 20px;
    font-weight: 700;
}

.nf-info-chave {
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
}

.nf-info-pedido {
    flex: 0 1 260px;
}

.nf-select-all {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 4px 0;
    font-size: 13px;
    font-weight: 600;
}

.nf-item-card {
    position: relative;
    padding: 16px 20px;
    margin-bottom: 16px;
    border-radius: 8px;
}

.nf-item-badge {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #1565c0;
    color: white;
    padding: 3px 10px;
    border-radius: 0 8px 0 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.nf-item-header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 12px;
    padding-right: 90px;
}

.nf-item-checkbox {
    margin-top: 2px !important;
}

.nf-item-title {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.nf-item-title-tag {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.7;
}

.nf-item-title-desc {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
}

.nf-item-fields {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px 20px;
    padding: 12px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.nf-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.nf-field-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    opacity: 0.65;
}

.nf-field-value {
    font-size: 14px;
    font-weight: 600;
}

.nf-item-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 12px;
}

.nf-item-actions-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
}

.nf-item-actions-row--end {
    justify-content: flex-end;
}

.nf-item-actions-field {
    flex: 1 1 220px;
    min-width: 180px;
}

.nf-item-actions-btn {
    flex: 0 0 auto;
    box-shadow: none !important;
}

.v-data-table thead th,
.v-data-table tbody td {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

::-webkit-scrollbar {
    height: 5px !important;
}

::-webkit-scrollbar-thumb {
    background-color: #230BC1 !important;
}

.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
    height: 48px;
    border-bottom: 0;
}

.v-application--is-ltr .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    text-align: center !important;
    border-bottom: 0 !important;
}

.statusTd {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 53px !important;
}

.activeCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%;
    height: 0.5rem;
    width: 0.5rem;
    opacity: 80%;
    background-color: rgb(34 197 94);
}

.inactiveCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%;
    height: 0.5rem;
    width: 0.5rem;
    opacity: 80%;
    background-color: #F00;
}

.v-application .elevation-1 {
    box-shadow: none !important;
}

.mdi-arrow-up::before {
    font-size: 15px !important;
}

.mdi-arrow-up::after {
    font-size: 15px !important;
}

.actionIcon {
    font-size: 18px !important;
}

.v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;
    ;
}

.v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
}

.v-text-field .v-input__slot {
    padding: 0 !important;
}

.filterInput {
    outline: none;
    border: 1px solid #e1e1e1;
    color: #000;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
}

.filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 0.6;
    filter: invert(0.8);
}

.container {
    margin-right: 0;
    margin-left: 0;
    max-width: 100%;
}

.v-slide-group__prev,
.v-slide-group__prev--disabled {
    display: none !important;
}

.v-slide-group__next--disabled,
.v-slide-group__prev--disabled {
    display: none !important;
}

.addButton {
    display: flex;
    gap: "12px"
}

::v-deep(.v-data-table td) {
    overflow: hidden !important;
}

::v-deep(.v-text-field__details) {
    display: none !important;
}

</style>